document.addEventListener("DOMContentLoaded", async function() {
  // Evitar mostrar repetidamente
  if(localStorage.getItem("geoPopupDismissedUS")) {
    return;
  }

  try {
    // Obtener el dominio actual
    const currentHostname = window.location.hostname;
    
    // Detectar país usando IP API
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    const userCountry = data.country_code;
    
    // Mapeo de país a dominio correcto
    const countryToDomain = {
      "MX": "packsys.com",
      "US": "packsys.us",
      "GT": "packsys.gt",
      "CR": "packsys.cr"
    };
    
    const countryToTitle = {
      "MX": "Tienda México",
      "US": "United States Store",
      "GT": "Tienda Guatemala",
      "CR": "Tienda Costa Rica"
    };
    
    const countryToMessage = {
      "MX": "Detectamos que estás visitando desde México. ¿Deseas cambiar a nuestra tienda de México?",
      "US": "We noticed you're visiting from the United States. Would you like to switch to our US store?",
      "GT": "Detectamos que estás visitando desde Guatemala. ¿Deseas cambiar a nuestra tienda de Guatemala?",
      "CR": "Detectamos que estás visitando desde Costa Rica. ¿Deseas cambiar a nuestra tienda de Costa Rica?"
    };
    
    const countryToButtonText = {
      "MX": "Ir a tienda México",
      "US": "Switch Store",
      "GT": "Ir a tienda Guatemala",
      "CR": "Ir a tienda Costa Rica"
    };
    
    // Verificar si el país está en nuestra lista
    if (!countryToDomain[userCountry]) {
      return; // País no soportado, no mostrar popup
    }
    
    const expectedDomain = countryToDomain[userCountry];
    
    // Si el usuario YA ESTÁ en el dominio correcto para su país, NO mostrar popup
    if (currentHostname === expectedDomain) {
      console.log("Usuario ya está en el store correcto para su país:", userCountry);
      return;
    }
    
    // Si llegamos aquí, el usuario NO está en el store correcto, mostrar popup
    const redirectUrl = `https://${expectedDomain}`;
    const title = countryToTitle[userCountry];
    const message = countryToMessage[userCountry];
    const buttonText = countryToButtonText[userCountry];
    
    // Configurar el contenido del popup
    document.getElementById("geo-title-us").innerText = title;
    document.getElementById("geo-message-us").innerText = message;
    const confirmBtn = document.getElementById("geo-confirm-us");
    confirmBtn.href = redirectUrl;
    confirmBtn.innerHTML = `${buttonText} <span class="geo-btn-arrow-us">→</span>`;
    
    // Mostrar popup
    const overlay = document.getElementById("geo-popup-overlay-us");
    overlay.style.display = "flex";
    
    // Botón cerrar (permanecer aquí)
    document.getElementById("geo-close-us").addEventListener("click", function() {
      localStorage.setItem("geoPopupDismissedUS", "true");
      overlay.style.display = "none";
    });
    
    // También cerrar si se hace clic fuera del popup
    overlay.addEventListener("click", function(e) {
      if (e.target === overlay) {
        localStorage.setItem("geoPopupDismissedUS", "true");
        overlay.style.display = "none";
      }
    });
    
  } catch(e) {
    console.log("Geo popup error", e);
  }
});
